import * as l4j from './logger';

/**
 * Configures the root logger.
 */
export default function configureLogging(): void {
  const log = l4j.getLogger('simManagement');
  log.removeAllAppenders();

  const appender = new l4j.BrowserConsoleAppender();
  appender.setLayout(new l4j.PatternLayout('%c (%p) - %m'));
  log.addAppender(appender);
}
